<script>
import Rainbow from '@/components/Rainbow.vue'
import { mapState } from 'vuex'
import track from '@/plugins/track'

export default {
  name: 'PlanCard',
  props: ['plan', 'alt'],
  components: {
    Rainbow,
  },
  computed: {
    ...mapState(['plans']),
    bullets() {
      if(typeof this.plan.description == 'string') {
        return this.plan.description.split(' | ').filter(p => p != 'bestvalue')
      }
      return []
    },
    bestValue() {
      if(typeof this.plan.description == 'string') {
        return this.plan.description.split(' | ').includes('bestvalue')
      }
      return false
    }
  },
  methods: {
    gotoPlan(plan) {
      track({
        event: 'click',
        category: 'home',
        action: `learnmore-${ this.plan.name }`,
        label: `learnmore-${ this.plan.name }`,
      })
      this.$store.dispatch('signup/SET_STEP', 0)
      this.$store.dispatch('signup/RESET')
      this.$router.push({ path: `/plans/${ plan.id }/signup`})
    },
    gotoSignup() {
      track({
        event: 'click',
        category: 'home',
        action: `enroll-plan-${ this.plan.name }`,
        label: `enroll-plan-${ this.plan.name }`,
      })
      this.$router.push({ path: `/plans/${ this.plan.id }`})
    },
  },
}
</script>

<template>
  <v-card
    tile
    class="plancard elevation-5 flex d-flex flex-column white lighten-1 pa-3"
  >
    <div v-if="bestValue" class="my-0 py-1 pt-2 mx-auto bestvalue">BEST VALUE</div>
    <v-card-title primary-title class="mx-auto text-center mb-6">
      <h3 class="plan-header text-center mb-0 pa-0 mx-auto">
        {{ plan.name }}
      </h3>
      <Rainbow class="plan-rainbow py-0 my-0 mx-auto" thickness="6px" style="width: 100%; min-width: 200px;" />
    </v-card-title>
    <v-card-text class="flex pa-0">
      <div class="cost text-center px-12">
        <span class="dollarSup">$</span>{{ plan.costPerMonth }}<span style="top: -10px; position: relative; font-size: 30px;">*</span><span class="mo">/mo</span>
      </div>
      <div class="text-center px-4">*Requires 12 month commitment</div>
      <v-divider light class="mt-2"></v-divider>
      <div class="pa-4 text-center px-12">
        <h3 class="plan-headline">Includes:</h3>
      </div>
      <v-divider light class="mb-6"></v-divider>
      <v-list-item
        class="bullet px-12 py-0 my-0"
        v-for="(item, i) in bullets"
        :key="i"
        >
        <v-list-item-content class="my-0 py-0">
          <v-row class="my-0 py-0">
            <v-col align="right" cols="2">
              <v-icon class="checkmark mr-1">mdi-check-circle</v-icon>
            </v-col>
            <v-col class="pt-4 font-weight-bold bullet-text" align="left" cols="10">{{ item }}</v-col>
          </v-row>
        </v-list-item-content>
      </v-list-item>
    </v-card-text>
    <!-- make CTAs optional -->
    <v-card-actions v-if="!alt" class="d-flex flex-column px-12">
      <v-btn block elevation="0" x-large class="mt-4 greenbtn"
        @click="gotoPlan(plan)"
      >Enroll</v-btn>
      <v-btn text small class="mt-4" @click="gotoSignup">Learn More</v-btn>
    </v-card-actions>
  </v-card>
</template>

<style lang="scss" scoped>
.plancard {
  width: 100%;
  height: 100%;
}
.plan-header {
  color: $hpp-darkblue;
  font-size: 32px;
  font-weight: 400 !important;
  white-space: pre-wrap;
  word-break: keep-all;

}
.plan-headline {
  font-size: 18px;
}
.mo {
  font-size: 24px;
}
.cost {
  color: $hpp-darkblue;
  font-size: 48px;
}
.dollarSup {
  vertical-align: top;
  font-size: 24px;
  line-height: 2em;
  top: -10px;
  position: relative;
}
.bullet {
  min-height: 0 !important;
}
.bullet-text {
  color: #444;
}
.checkmark {
  color: $hpp-blue !important;
}
.rounded-card{
  border-radius:8px !important;
  border: solid 1px $hpp-grey;
}
.bestvalue {
  text-align: center;
  border-bottom: none;
  border-top-left-radius: 4px !important;
  border-top-right-radius: 4px !important;
  font-size: 16px;
  font-weight: 700;
  width: 70%;
  left: 15%;
  top: -36px;
  position: absolute;
  background-color: $hpp-orange;
  color: white;
}

@media only screen and (max-width: 960px) {
  .plancard {
    max-width: 90%;
    margin: 0 auto;
  }
  .plan-header {
    min-height: 0;
  }
  .plan-rainbow {
    max-width: 40%;
  }
  .cost {
    font-size: 48px;
  }
  .dollarSup {
    font-size: 20px;
    line-height: 2em;
    top: -15px;
  }
}

@media only screen and (max-width: 600px) {
  .plan-header {
    font-size: 28px;
    line-height: 28px !important;
  }
  .mo {
    font-size: 24px;
  }
  .cost {
    font-size: 48px;
  }
  .dollarSup {
    font-size: 20px;
    line-height: 2em;
    top: -15px;
  }
}
</style>
